import { render, staticRenderFns } from "./BillingDetailBaseForm.vue?vue&type=template&id=70833d44&scoped=true&"
import script from "./BillingDetailBaseForm.vue?vue&type=script&lang=js&"
export * from "./BillingDetailBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70833d44",
  null
  
)

export default component.exports